import React from "react";
import { Link } from "react-router-dom";
import alternateYoga from "../../Assets/alternate-yoga.webp";
import suryaNamaskar from "../../Assets/surya-namaskar.webp";
import chandraNamaskar from "../../Assets/chandra-namaskar.webp";
import "./YogaVariations.css";

// `to` is the page the button under the chart opens; leave it out and the
// chart shows no button.
const FLOWS = [
  {
    title: "Alternate Yoga",
    src: alternateYoga,
    to: "/alternate-asana",
    cta: "Explore Alternate Asana",
  },
  {
    title: "Surya Namaskar",
    src: suryaNamaskar,
    to: "/warm-up/surya-namaskar",
    cta: "Explore Surya Namaskar",
  },
  {
    title: "Chandra Namaskar",
    src: chandraNamaskar,
    to: "/warm-up/chandra-namaskar",
    cta: "Explore Chandra Namaskar",
  },
];

const YogaFlows = () => (
  <section className="yoga-variations yoga-flows">
    <div className="yoga-variations-grid yoga-flows-grid">
      {FLOWS.map((flow) => (
        <figure className="yoga-variation-card yoga-flow-card" key={flow.title}>
          <div className="yoga-flow-frame">
            <img src={flow.src} alt={flow.title} loading="lazy" />
          </div>
          {flow.to && (
            <Link className="yoga-variation-link" to={flow.to}>
              {flow.cta}
            </Link>
          )}
        </figure>
      ))}
    </div>
  </section>
);

export default YogaFlows;
